exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".scan-item{width:90%;height:300px;margin:5%;border:2px dashed #f2f2f2;border-radius:5px}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Desktop/Sourcetree/Mariminterfood/pos_ui-Develop/src/components/pos/scan.vue"],"names":[],"mappings":"AACA,WACE,UAAW,AACX,aAAc,AACd,UAAW,AACX,0BAA2B,AAC3B,iBAAmB,CACpB","file":"scan.vue","sourcesContent":["\n.scan-item {\n  width: 90%;\n  height: 300px;\n  margin: 5%;\n  border: 2px #f2f2f2 dashed;\n  border-radius: 5px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f3f9720","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pos/scan.vue
// module id = 1180
// module chunks = 0